import React from 'react';
import { LiveChickenChart } from '../components/LiveChickenChart';
import { LiveChickenTable } from '../components/LiveChickenTable';
import { MarketIQLayout } from '../components/MarketIQLayout';
import { MarketIQNav } from '../components/MarketIQNav';
export function MarketIQChicken() {
  return <MarketIQLayout activeSection="chicken" data-id="element-442">
      <LiveChickenChart data-id="element-443" />
      <MarketIQNav current="chicken" data-id="element-444" />
      <LiveChickenTable data-id="element-445" />
    </MarketIQLayout>;
}